import { PersonDto } from "../api";

export interface PersonLookup {
  [personId: number]: PersonDto;
}

export type WithId = { id: number };

export function isWithId(obj: object): obj is WithId {
  // @ts-ignore
  return Object.hasOwn(obj, "id") && typeof obj.id == "number";
}

export type LookupType<T> = {
  [id: number | string]: T;
};
